import React, { useState, useCallback } from 'react';
import Autosuggest from 'react-autosuggest';
import PropTypes from 'prop-types';
import debounce from 'lodash/debounce';

import './styles.css';

const AsyncAutosuggest = props => {
  const {
    placeholder = 'Search',
    value = '',
    name,
    onChange,
    onSelected,
    onSearchRequested,
  } = props;

  const [suggestions, setSuggestions] = useState([]);

  const getSuggestionValue = suggestion => suggestion.label;

  const renderSuggestion = suggestion => suggestion.label;

  const debounceRequest = useCallback(
    debounce(value => {
      onSearchRequested(value).then((records = []) => {
        setSuggestions(records);
      });
    }, 500),
    []
  );

  const debounceChange = useCallback(
    debounce(value => {
      onChange(name, value);
    }, 20),
    []
  );

  const onSuggestionsFetchRequested = ({ value, reason }) => {
    if (reason === 'input-changed') {
      debounceRequest(value);
    }
  };

  const onChangeInput = (event, { newValue, method }) => {
    if (method !== 'click') {
      debounceChange(newValue);
    }
  };

  const onSuggestionsClearRequested = () => {
    setSuggestions([]);
  };

  const onSuggestionSelected = (event, { suggestion }) => {
    onSelected(name, suggestion);
    setSuggestions([]);
  };

  return (
    <Autosuggest
      suggestions={suggestions}
      onSuggestionsFetchRequested={onSuggestionsFetchRequested}
      onSuggestionsClearRequested={onSuggestionsClearRequested}
      getSuggestionValue={getSuggestionValue}
      renderSuggestion={renderSuggestion}
      onSuggestionSelected={onSuggestionSelected}
      inputProps={{
        placeholder,
        value,
        onChange: onChangeInput,
      }}
    />
  );
};

AsyncAutosuggest.propTypes = {
  value: PropTypes.string,
  name: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  onSelected: PropTypes.func.isRequired,
  onSearchRequested: PropTypes.func.isRequired,
};

export default AsyncAutosuggest;
